import createAPIRequest from "../helpers/createAPIRequest";
import store from "../store/index";
//--------------------
// edit combat action
//--------------------
export default async function useEditCombatAction(this_action) {
  return new Promise((resolve, reject) => {
    //--------------
    // access store
    //--------------
    const this_store = store;
    //--------------------
    // set api call parms
    //--------------------
    let parm_slug = "";

    if (this_action.slug != "") {
      parm_slug = this_action.slug;
    }

    let request_parms = {
      endpoint: "api/v1/combat-actions/",
      slug: parm_slug,
    };
    //--------------------
    // create api request
    //--------------------
    let request = createAPIRequest(request_parms);
    //---------------
    // set api parms
    //---------------
    let api_parms = {
      api_request: request,
      payload: this_action,
    };
    //----------
    // call api
    //----------
    console.log('useEditCombatAction api_parms = ', api_parms)
    this_store
      .dispatch("combat/editCombatAction", api_parms)
      .then((response) => {
        console.log('useEditCombatAction response = ', response)
        resolve(response);
      })
      .catch((err) => {
        console.log('useEditCombatAction error = ', err)
        reject(err);
      });
  });
}
